/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router";

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as IndexImport } from "./routes/index";
import { Route as unauthedLayoutImport } from "./routes/(unauthed)/_layout";
import { Route as authedLayoutImport } from "./routes/(authed)/_layout";
import { Route as unauthedLayoutLoginImport } from "./routes/(unauthed)/_layout.login";
import { Route as authedLayoutSettingsImport } from "./routes/(authed)/_layout.settings";
import { Route as authedLayoutReportsImport } from "./routes/(authed)/_layout.reports";
import { Route as authedLayoutBenchmarksImport } from "./routes/(authed)/_layout.benchmarks";
import { Route as authedLayoutContactsRouteImport } from "./routes/(authed)/_layout.contacts.route";
import { Route as authedLayoutBookingsRouteImport } from "./routes/(authed)/_layout/bookings.route";
import { Route as authedLayoutSettingsIndexImport } from "./routes/(authed)/_layout.settings.index";
import { Route as authedLayoutReportsIndexImport } from "./routes/(authed)/_layout.reports.index";
import { Route as authedLayoutContactsIndexImport } from "./routes/(authed)/_layout.contacts.index";
import { Route as authedLayoutSettingsUsersImport } from "./routes/(authed)/_layout.settings.users";
import { Route as authedLayoutSettingsProfileImport } from "./routes/(authed)/_layout.settings.profile";
import { Route as authedLayoutReportsSlugImport } from "./routes/(authed)/_layout.reports.$slug";
import { Route as authedLayoutContactsContactIdImport } from "./routes/(authed)/_layout.contacts.$contactId";
import { Route as authedLayoutBookingsTabbedImport } from "./routes/(authed)/_layout/bookings._tabbed";
import { Route as authedLayoutBookingsBookingIdImport } from "./routes/(authed)/_layout/bookings.$bookingId";
import { Route as authedLayoutBookingsTabbedIndexImport } from "./routes/(authed)/_layout/bookings._tabbed.index";
import { Route as authedLayoutBookingsTabbedSummaryImport } from "./routes/(authed)/_layout/bookings._tabbed.summary";

// Create Virtual Routes

const unauthedImport = createFileRoute("/(unauthed)")();
const authedImport = createFileRoute("/(authed)")();

// Create/Update Routes

const unauthedRoute = unauthedImport.update({
  id: "/(unauthed)",
  path: "/",
  getParentRoute: () => rootRoute,
} as any);

const authedRoute = authedImport.update({
  id: "/(authed)",
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRoute,
} as any);

const unauthedLayoutRoute = unauthedLayoutImport.update({
  id: "/_layout",
  getParentRoute: () => unauthedRoute,
} as any);

const authedLayoutRoute = authedLayoutImport.update({
  id: "/_layout",
  getParentRoute: () => authedRoute,
} as any);

const unauthedLayoutLoginRoute = unauthedLayoutLoginImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => unauthedLayoutRoute,
} as any);

const authedLayoutSettingsRoute = authedLayoutSettingsImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => authedLayoutRoute,
} as any);

const authedLayoutReportsRoute = authedLayoutReportsImport.update({
  id: "/reports",
  path: "/reports",
  getParentRoute: () => authedLayoutRoute,
} as any);

const authedLayoutBenchmarksRoute = authedLayoutBenchmarksImport.update({
  id: "/benchmarks",
  path: "/benchmarks",
  getParentRoute: () => authedLayoutRoute,
} as any);

const authedLayoutContactsRouteRoute = authedLayoutContactsRouteImport.update({
  id: "/contacts",
  path: "/contacts",
  getParentRoute: () => authedLayoutRoute,
} as any);

const authedLayoutBookingsRouteRoute = authedLayoutBookingsRouteImport.update({
  id: "/bookings",
  path: "/bookings",
  getParentRoute: () => authedLayoutRoute,
} as any);

const authedLayoutSettingsIndexRoute = authedLayoutSettingsIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => authedLayoutSettingsRoute,
} as any);

const authedLayoutReportsIndexRoute = authedLayoutReportsIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => authedLayoutReportsRoute,
} as any);

const authedLayoutContactsIndexRoute = authedLayoutContactsIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => authedLayoutContactsRouteRoute,
} as any);

const authedLayoutSettingsUsersRoute = authedLayoutSettingsUsersImport.update({
  id: "/users",
  path: "/users",
  getParentRoute: () => authedLayoutSettingsRoute,
} as any);

const authedLayoutSettingsProfileRoute = authedLayoutSettingsProfileImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => authedLayoutSettingsRoute,
} as any);

const authedLayoutReportsSlugRoute = authedLayoutReportsSlugImport.update({
  id: "/$slug",
  path: "/$slug",
  getParentRoute: () => authedLayoutReportsRoute,
} as any);

const authedLayoutContactsContactIdRoute = authedLayoutContactsContactIdImport.update({
  id: "/$contactId",
  path: "/$contactId",
  getParentRoute: () => authedLayoutContactsRouteRoute,
} as any);

const authedLayoutBookingsTabbedRoute = authedLayoutBookingsTabbedImport.update({
  id: "/_tabbed",
  getParentRoute: () => authedLayoutBookingsRouteRoute,
} as any);

const authedLayoutBookingsBookingIdRoute = authedLayoutBookingsBookingIdImport.update({
  id: "/$bookingId",
  path: "/$bookingId",
  getParentRoute: () => authedLayoutBookingsRouteRoute,
} as any);

const authedLayoutBookingsTabbedIndexRoute = authedLayoutBookingsTabbedIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => authedLayoutBookingsTabbedRoute,
} as any);

const authedLayoutBookingsTabbedSummaryRoute = authedLayoutBookingsTabbedSummaryImport.update({
  id: "/summary",
  path: "/summary",
  getParentRoute: () => authedLayoutBookingsTabbedRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    "/(authed)": {
      id: "/(authed)";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof authedImport;
      parentRoute: typeof rootRoute;
    };
    "/(authed)/_layout": {
      id: "/(authed)/_layout";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof authedLayoutImport;
      parentRoute: typeof authedRoute;
    };
    "/(unauthed)": {
      id: "/(unauthed)";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof unauthedImport;
      parentRoute: typeof rootRoute;
    };
    "/(unauthed)/_layout": {
      id: "/(unauthed)/_layout";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof unauthedLayoutImport;
      parentRoute: typeof unauthedRoute;
    };
    "/(authed)/_layout/bookings": {
      id: "/(authed)/_layout/bookings";
      path: "/bookings";
      fullPath: "/bookings";
      preLoaderRoute: typeof authedLayoutBookingsRouteImport;
      parentRoute: typeof authedLayoutImport;
    };
    "/(authed)/_layout/contacts": {
      id: "/(authed)/_layout/contacts";
      path: "/contacts";
      fullPath: "/contacts";
      preLoaderRoute: typeof authedLayoutContactsRouteImport;
      parentRoute: typeof authedLayoutImport;
    };
    "/(authed)/_layout/benchmarks": {
      id: "/(authed)/_layout/benchmarks";
      path: "/benchmarks";
      fullPath: "/benchmarks";
      preLoaderRoute: typeof authedLayoutBenchmarksImport;
      parentRoute: typeof authedLayoutImport;
    };
    "/(authed)/_layout/reports": {
      id: "/(authed)/_layout/reports";
      path: "/reports";
      fullPath: "/reports";
      preLoaderRoute: typeof authedLayoutReportsImport;
      parentRoute: typeof authedLayoutImport;
    };
    "/(authed)/_layout/settings": {
      id: "/(authed)/_layout/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof authedLayoutSettingsImport;
      parentRoute: typeof authedLayoutImport;
    };
    "/(unauthed)/_layout/login": {
      id: "/(unauthed)/_layout/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof unauthedLayoutLoginImport;
      parentRoute: typeof unauthedLayoutImport;
    };
    "/(authed)/_layout/bookings/$bookingId": {
      id: "/(authed)/_layout/bookings/$bookingId";
      path: "/$bookingId";
      fullPath: "/bookings/$bookingId";
      preLoaderRoute: typeof authedLayoutBookingsBookingIdImport;
      parentRoute: typeof authedLayoutBookingsRouteImport;
    };
    "/(authed)/_layout/bookings/_tabbed": {
      id: "/(authed)/_layout/bookings/_tabbed";
      path: "";
      fullPath: "/bookings";
      preLoaderRoute: typeof authedLayoutBookingsTabbedImport;
      parentRoute: typeof authedLayoutBookingsRouteImport;
    };
    "/(authed)/_layout/contacts/$contactId": {
      id: "/(authed)/_layout/contacts/$contactId";
      path: "/$contactId";
      fullPath: "/contacts/$contactId";
      preLoaderRoute: typeof authedLayoutContactsContactIdImport;
      parentRoute: typeof authedLayoutContactsRouteImport;
    };
    "/(authed)/_layout/reports/$slug": {
      id: "/(authed)/_layout/reports/$slug";
      path: "/$slug";
      fullPath: "/reports/$slug";
      preLoaderRoute: typeof authedLayoutReportsSlugImport;
      parentRoute: typeof authedLayoutReportsImport;
    };
    "/(authed)/_layout/settings/profile": {
      id: "/(authed)/_layout/settings/profile";
      path: "/profile";
      fullPath: "/settings/profile";
      preLoaderRoute: typeof authedLayoutSettingsProfileImport;
      parentRoute: typeof authedLayoutSettingsImport;
    };
    "/(authed)/_layout/settings/users": {
      id: "/(authed)/_layout/settings/users";
      path: "/users";
      fullPath: "/settings/users";
      preLoaderRoute: typeof authedLayoutSettingsUsersImport;
      parentRoute: typeof authedLayoutSettingsImport;
    };
    "/(authed)/_layout/contacts/": {
      id: "/(authed)/_layout/contacts/";
      path: "/";
      fullPath: "/contacts/";
      preLoaderRoute: typeof authedLayoutContactsIndexImport;
      parentRoute: typeof authedLayoutContactsRouteImport;
    };
    "/(authed)/_layout/reports/": {
      id: "/(authed)/_layout/reports/";
      path: "/";
      fullPath: "/reports/";
      preLoaderRoute: typeof authedLayoutReportsIndexImport;
      parentRoute: typeof authedLayoutReportsImport;
    };
    "/(authed)/_layout/settings/": {
      id: "/(authed)/_layout/settings/";
      path: "/";
      fullPath: "/settings/";
      preLoaderRoute: typeof authedLayoutSettingsIndexImport;
      parentRoute: typeof authedLayoutSettingsImport;
    };
    "/(authed)/_layout/bookings/_tabbed/summary": {
      id: "/(authed)/_layout/bookings/_tabbed/summary";
      path: "/summary";
      fullPath: "/bookings/summary";
      preLoaderRoute: typeof authedLayoutBookingsTabbedSummaryImport;
      parentRoute: typeof authedLayoutBookingsTabbedImport;
    };
    "/(authed)/_layout/bookings/_tabbed/": {
      id: "/(authed)/_layout/bookings/_tabbed/";
      path: "/";
      fullPath: "/bookings/";
      preLoaderRoute: typeof authedLayoutBookingsTabbedIndexImport;
      parentRoute: typeof authedLayoutBookingsTabbedImport;
    };
  }
}

// Create and export the route tree

interface authedLayoutBookingsTabbedRouteChildren {
  authedLayoutBookingsTabbedSummaryRoute: typeof authedLayoutBookingsTabbedSummaryRoute;
  authedLayoutBookingsTabbedIndexRoute: typeof authedLayoutBookingsTabbedIndexRoute;
}

const authedLayoutBookingsTabbedRouteChildren: authedLayoutBookingsTabbedRouteChildren = {
  authedLayoutBookingsTabbedSummaryRoute: authedLayoutBookingsTabbedSummaryRoute,
  authedLayoutBookingsTabbedIndexRoute: authedLayoutBookingsTabbedIndexRoute,
};

const authedLayoutBookingsTabbedRouteWithChildren = authedLayoutBookingsTabbedRoute._addFileChildren(
  authedLayoutBookingsTabbedRouteChildren,
);

interface authedLayoutBookingsRouteRouteChildren {
  authedLayoutBookingsBookingIdRoute: typeof authedLayoutBookingsBookingIdRoute;
  authedLayoutBookingsTabbedRoute: typeof authedLayoutBookingsTabbedRouteWithChildren;
}

const authedLayoutBookingsRouteRouteChildren: authedLayoutBookingsRouteRouteChildren = {
  authedLayoutBookingsBookingIdRoute: authedLayoutBookingsBookingIdRoute,
  authedLayoutBookingsTabbedRoute: authedLayoutBookingsTabbedRouteWithChildren,
};

const authedLayoutBookingsRouteRouteWithChildren = authedLayoutBookingsRouteRoute._addFileChildren(
  authedLayoutBookingsRouteRouteChildren,
);

interface authedLayoutContactsRouteRouteChildren {
  authedLayoutContactsContactIdRoute: typeof authedLayoutContactsContactIdRoute;
  authedLayoutContactsIndexRoute: typeof authedLayoutContactsIndexRoute;
}

const authedLayoutContactsRouteRouteChildren: authedLayoutContactsRouteRouteChildren = {
  authedLayoutContactsContactIdRoute: authedLayoutContactsContactIdRoute,
  authedLayoutContactsIndexRoute: authedLayoutContactsIndexRoute,
};

const authedLayoutContactsRouteRouteWithChildren = authedLayoutContactsRouteRoute._addFileChildren(
  authedLayoutContactsRouteRouteChildren,
);

interface authedLayoutReportsRouteChildren {
  authedLayoutReportsSlugRoute: typeof authedLayoutReportsSlugRoute;
  authedLayoutReportsIndexRoute: typeof authedLayoutReportsIndexRoute;
}

const authedLayoutReportsRouteChildren: authedLayoutReportsRouteChildren = {
  authedLayoutReportsSlugRoute: authedLayoutReportsSlugRoute,
  authedLayoutReportsIndexRoute: authedLayoutReportsIndexRoute,
};

const authedLayoutReportsRouteWithChildren = authedLayoutReportsRoute._addFileChildren(
  authedLayoutReportsRouteChildren,
);

interface authedLayoutSettingsRouteChildren {
  authedLayoutSettingsProfileRoute: typeof authedLayoutSettingsProfileRoute;
  authedLayoutSettingsUsersRoute: typeof authedLayoutSettingsUsersRoute;
  authedLayoutSettingsIndexRoute: typeof authedLayoutSettingsIndexRoute;
}

const authedLayoutSettingsRouteChildren: authedLayoutSettingsRouteChildren = {
  authedLayoutSettingsProfileRoute: authedLayoutSettingsProfileRoute,
  authedLayoutSettingsUsersRoute: authedLayoutSettingsUsersRoute,
  authedLayoutSettingsIndexRoute: authedLayoutSettingsIndexRoute,
};

const authedLayoutSettingsRouteWithChildren = authedLayoutSettingsRoute._addFileChildren(
  authedLayoutSettingsRouteChildren,
);

interface authedLayoutRouteChildren {
  authedLayoutBookingsRouteRoute: typeof authedLayoutBookingsRouteRouteWithChildren;
  authedLayoutContactsRouteRoute: typeof authedLayoutContactsRouteRouteWithChildren;
  authedLayoutBenchmarksRoute: typeof authedLayoutBenchmarksRoute;
  authedLayoutReportsRoute: typeof authedLayoutReportsRouteWithChildren;
  authedLayoutSettingsRoute: typeof authedLayoutSettingsRouteWithChildren;
}

const authedLayoutRouteChildren: authedLayoutRouteChildren = {
  authedLayoutBookingsRouteRoute: authedLayoutBookingsRouteRouteWithChildren,
  authedLayoutContactsRouteRoute: authedLayoutContactsRouteRouteWithChildren,
  authedLayoutBenchmarksRoute: authedLayoutBenchmarksRoute,
  authedLayoutReportsRoute: authedLayoutReportsRouteWithChildren,
  authedLayoutSettingsRoute: authedLayoutSettingsRouteWithChildren,
};

const authedLayoutRouteWithChildren = authedLayoutRoute._addFileChildren(authedLayoutRouteChildren);

interface authedRouteChildren {
  authedLayoutRoute: typeof authedLayoutRouteWithChildren;
}

const authedRouteChildren: authedRouteChildren = {
  authedLayoutRoute: authedLayoutRouteWithChildren,
};

const authedRouteWithChildren = authedRoute._addFileChildren(authedRouteChildren);

interface unauthedLayoutRouteChildren {
  unauthedLayoutLoginRoute: typeof unauthedLayoutLoginRoute;
}

const unauthedLayoutRouteChildren: unauthedLayoutRouteChildren = {
  unauthedLayoutLoginRoute: unauthedLayoutLoginRoute,
};

const unauthedLayoutRouteWithChildren = unauthedLayoutRoute._addFileChildren(unauthedLayoutRouteChildren);

interface unauthedRouteChildren {
  unauthedLayoutRoute: typeof unauthedLayoutRouteWithChildren;
}

const unauthedRouteChildren: unauthedRouteChildren = {
  unauthedLayoutRoute: unauthedLayoutRouteWithChildren,
};

const unauthedRouteWithChildren = unauthedRoute._addFileChildren(unauthedRouteChildren);

export interface FileRoutesByFullPath {
  "/": typeof unauthedLayoutRouteWithChildren;
  "/bookings": typeof authedLayoutBookingsTabbedRouteWithChildren;
  "/contacts": typeof authedLayoutContactsRouteRouteWithChildren;
  "/benchmarks": typeof authedLayoutBenchmarksRoute;
  "/reports": typeof authedLayoutReportsRouteWithChildren;
  "/settings": typeof authedLayoutSettingsRouteWithChildren;
  "/login": typeof unauthedLayoutLoginRoute;
  "/bookings/$bookingId": typeof authedLayoutBookingsBookingIdRoute;
  "/contacts/$contactId": typeof authedLayoutContactsContactIdRoute;
  "/reports/$slug": typeof authedLayoutReportsSlugRoute;
  "/settings/profile": typeof authedLayoutSettingsProfileRoute;
  "/settings/users": typeof authedLayoutSettingsUsersRoute;
  "/contacts/": typeof authedLayoutContactsIndexRoute;
  "/reports/": typeof authedLayoutReportsIndexRoute;
  "/settings/": typeof authedLayoutSettingsIndexRoute;
  "/bookings/summary": typeof authedLayoutBookingsTabbedSummaryRoute;
  "/bookings/": typeof authedLayoutBookingsTabbedIndexRoute;
}

export interface FileRoutesByTo {
  "/": typeof unauthedLayoutRouteWithChildren;
  "/bookings": typeof authedLayoutBookingsTabbedIndexRoute;
  "/benchmarks": typeof authedLayoutBenchmarksRoute;
  "/login": typeof unauthedLayoutLoginRoute;
  "/bookings/$bookingId": typeof authedLayoutBookingsBookingIdRoute;
  "/contacts/$contactId": typeof authedLayoutContactsContactIdRoute;
  "/reports/$slug": typeof authedLayoutReportsSlugRoute;
  "/settings/profile": typeof authedLayoutSettingsProfileRoute;
  "/settings/users": typeof authedLayoutSettingsUsersRoute;
  "/contacts": typeof authedLayoutContactsIndexRoute;
  "/reports": typeof authedLayoutReportsIndexRoute;
  "/settings": typeof authedLayoutSettingsIndexRoute;
  "/bookings/summary": typeof authedLayoutBookingsTabbedSummaryRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  "/": typeof IndexRoute;
  "/(authed)": typeof authedRouteWithChildren;
  "/(authed)/_layout": typeof authedLayoutRouteWithChildren;
  "/(unauthed)": typeof unauthedRouteWithChildren;
  "/(unauthed)/_layout": typeof unauthedLayoutRouteWithChildren;
  "/(authed)/_layout/bookings": typeof authedLayoutBookingsRouteRouteWithChildren;
  "/(authed)/_layout/contacts": typeof authedLayoutContactsRouteRouteWithChildren;
  "/(authed)/_layout/benchmarks": typeof authedLayoutBenchmarksRoute;
  "/(authed)/_layout/reports": typeof authedLayoutReportsRouteWithChildren;
  "/(authed)/_layout/settings": typeof authedLayoutSettingsRouteWithChildren;
  "/(unauthed)/_layout/login": typeof unauthedLayoutLoginRoute;
  "/(authed)/_layout/bookings/$bookingId": typeof authedLayoutBookingsBookingIdRoute;
  "/(authed)/_layout/bookings/_tabbed": typeof authedLayoutBookingsTabbedRouteWithChildren;
  "/(authed)/_layout/contacts/$contactId": typeof authedLayoutContactsContactIdRoute;
  "/(authed)/_layout/reports/$slug": typeof authedLayoutReportsSlugRoute;
  "/(authed)/_layout/settings/profile": typeof authedLayoutSettingsProfileRoute;
  "/(authed)/_layout/settings/users": typeof authedLayoutSettingsUsersRoute;
  "/(authed)/_layout/contacts/": typeof authedLayoutContactsIndexRoute;
  "/(authed)/_layout/reports/": typeof authedLayoutReportsIndexRoute;
  "/(authed)/_layout/settings/": typeof authedLayoutSettingsIndexRoute;
  "/(authed)/_layout/bookings/_tabbed/summary": typeof authedLayoutBookingsTabbedSummaryRoute;
  "/(authed)/_layout/bookings/_tabbed/": typeof authedLayoutBookingsTabbedIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/bookings"
    | "/contacts"
    | "/benchmarks"
    | "/reports"
    | "/settings"
    | "/login"
    | "/bookings/$bookingId"
    | "/contacts/$contactId"
    | "/reports/$slug"
    | "/settings/profile"
    | "/settings/users"
    | "/contacts/"
    | "/reports/"
    | "/settings/"
    | "/bookings/summary"
    | "/bookings/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/bookings"
    | "/benchmarks"
    | "/login"
    | "/bookings/$bookingId"
    | "/contacts/$contactId"
    | "/reports/$slug"
    | "/settings/profile"
    | "/settings/users"
    | "/contacts"
    | "/reports"
    | "/settings"
    | "/bookings/summary";
  id:
    | "__root__"
    | "/"
    | "/(authed)"
    | "/(authed)/_layout"
    | "/(unauthed)"
    | "/(unauthed)/_layout"
    | "/(authed)/_layout/bookings"
    | "/(authed)/_layout/contacts"
    | "/(authed)/_layout/benchmarks"
    | "/(authed)/_layout/reports"
    | "/(authed)/_layout/settings"
    | "/(unauthed)/_layout/login"
    | "/(authed)/_layout/bookings/$bookingId"
    | "/(authed)/_layout/bookings/_tabbed"
    | "/(authed)/_layout/contacts/$contactId"
    | "/(authed)/_layout/reports/$slug"
    | "/(authed)/_layout/settings/profile"
    | "/(authed)/_layout/settings/users"
    | "/(authed)/_layout/contacts/"
    | "/(authed)/_layout/reports/"
    | "/(authed)/_layout/settings/"
    | "/(authed)/_layout/bookings/_tabbed/summary"
    | "/(authed)/_layout/bookings/_tabbed/";
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  authedRoute: typeof authedRouteWithChildren;
  unauthedRoute: typeof unauthedRouteWithChildren;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authedRoute: authedRouteWithChildren,
  unauthedRoute: unauthedRouteWithChildren,
};

export const routeTree = rootRoute._addFileChildren(rootRouteChildren)._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/(authed)",
        "/(unauthed)"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/(authed)": {
      "filePath": "(authed)",
      "children": [
        "/(authed)/_layout"
      ]
    },
    "/(authed)/_layout": {
      "filePath": "(authed)/_layout.tsx",
      "parent": "/(authed)",
      "children": [
        "/(authed)/_layout/bookings",
        "/(authed)/_layout/contacts",
        "/(authed)/_layout/benchmarks",
        "/(authed)/_layout/reports",
        "/(authed)/_layout/settings"
      ]
    },
    "/(unauthed)": {
      "filePath": "(unauthed)",
      "children": [
        "/(unauthed)/_layout"
      ]
    },
    "/(unauthed)/_layout": {
      "filePath": "(unauthed)/_layout.tsx",
      "parent": "/(unauthed)",
      "children": [
        "/(unauthed)/_layout/login"
      ]
    },
    "/(authed)/_layout/bookings": {
      "filePath": "(authed)/_layout/bookings.route.tsx",
      "parent": "/(authed)/_layout",
      "children": [
        "/(authed)/_layout/bookings/$bookingId",
        "/(authed)/_layout/bookings/_tabbed"
      ]
    },
    "/(authed)/_layout/contacts": {
      "filePath": "(authed)/_layout.contacts.route.tsx",
      "parent": "/(authed)/_layout",
      "children": [
        "/(authed)/_layout/contacts/$contactId",
        "/(authed)/_layout/contacts/"
      ]
    },
    "/(authed)/_layout/benchmarks": {
      "filePath": "(authed)/_layout.benchmarks.tsx",
      "parent": "/(authed)/_layout"
    },
    "/(authed)/_layout/reports": {
      "filePath": "(authed)/_layout.reports.tsx",
      "parent": "/(authed)/_layout",
      "children": [
        "/(authed)/_layout/reports/$slug",
        "/(authed)/_layout/reports/"
      ]
    },
    "/(authed)/_layout/settings": {
      "filePath": "(authed)/_layout.settings.tsx",
      "parent": "/(authed)/_layout",
      "children": [
        "/(authed)/_layout/settings/profile",
        "/(authed)/_layout/settings/users",
        "/(authed)/_layout/settings/"
      ]
    },
    "/(unauthed)/_layout/login": {
      "filePath": "(unauthed)/_layout.login.tsx",
      "parent": "/(unauthed)/_layout"
    },
    "/(authed)/_layout/bookings/$bookingId": {
      "filePath": "(authed)/_layout/bookings.$bookingId.tsx",
      "parent": "/(authed)/_layout/bookings"
    },
    "/(authed)/_layout/bookings/_tabbed": {
      "filePath": "(authed)/_layout/bookings._tabbed.tsx",
      "parent": "/(authed)/_layout/bookings",
      "children": [
        "/(authed)/_layout/bookings/_tabbed/summary",
        "/(authed)/_layout/bookings/_tabbed/"
      ]
    },
    "/(authed)/_layout/contacts/$contactId": {
      "filePath": "(authed)/_layout.contacts.$contactId.tsx",
      "parent": "/(authed)/_layout/contacts"
    },
    "/(authed)/_layout/reports/$slug": {
      "filePath": "(authed)/_layout.reports.$slug.tsx",
      "parent": "/(authed)/_layout/reports"
    },
    "/(authed)/_layout/settings/profile": {
      "filePath": "(authed)/_layout.settings.profile.tsx",
      "parent": "/(authed)/_layout/settings"
    },
    "/(authed)/_layout/settings/users": {
      "filePath": "(authed)/_layout.settings.users.tsx",
      "parent": "/(authed)/_layout/settings"
    },
    "/(authed)/_layout/contacts/": {
      "filePath": "(authed)/_layout.contacts.index.tsx",
      "parent": "/(authed)/_layout/contacts"
    },
    "/(authed)/_layout/reports/": {
      "filePath": "(authed)/_layout.reports.index.tsx",
      "parent": "/(authed)/_layout/reports"
    },
    "/(authed)/_layout/settings/": {
      "filePath": "(authed)/_layout.settings.index.tsx",
      "parent": "/(authed)/_layout/settings"
    },
    "/(authed)/_layout/bookings/_tabbed/summary": {
      "filePath": "(authed)/_layout/bookings._tabbed.summary.tsx",
      "parent": "/(authed)/_layout/bookings/_tabbed"
    },
    "/(authed)/_layout/bookings/_tabbed/": {
      "filePath": "(authed)/_layout/bookings._tabbed.index.tsx",
      "parent": "/(authed)/_layout/bookings/_tabbed"
    }
  }
}
ROUTE_MANIFEST_END */
